// extracted by mini-css-extract-plugin
export default {"operator":"MobileOperatorLogo-module__operator","operator__name":"MobileOperatorLogo-module__operator__name","logoWrapper":"MobileOperatorLogo-module__logoWrapper"};